import { Text } from "@mantine/core";
import { DataGridSelectionKeys, DBStatusResult, EntityClientAction, LookupFormAction } from "@mcurros2/microm";
import { Personal } from "./Personal";

export const ACTReasignarPersonal: EntityClientAction = {
    name: 'ACTReasignarPersonal',
    label: 'Reasignar Personal',
    title: <Text fw={700}>Reasignar Personal</Text>,
    refreshOnClose: true,
    dontRequireSelection: false,
    showActionInViewMode: true,
    views: ['perl_brwGestionPersonalDetalles'],
    onClick: async ({ entity, modal, selectedKeys, element, onClose }) => {

        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }

        const personal = entity as Personal;

        const procParms = {
            c_personal_id: selectedKeys?.[0]?.['c_personal_id'] ?? ''
        };

        let errores = '';

        if (!procParms.c_personal_id) {
            errores = 'Los registros seleccionados son inválidos';
        }

        await modal.open({
            modalProps: {
                title: <Text fw="700">Reasignar personal</Text>,
                size: 'xl'
            },
            focusOnClosed: element,
            content: <LookupFormAction
                lookupEntity={personal}
                viewName={personal.def.views.perl_brwGestionPersonal.name}
                title="Reasignar personal seleccionado"
                confirmContent="¿Está seguro de que desea reasignar el personal seleccionado?"
                onActionFinished={async () => { if (onClose) await onClose(); }}
                onOK={
                    async (keys: DataGridSelectionKeys, abortSignal: AbortSignal): Promise<DBStatusResult> => {
                        const abort_controller = new AbortController();

                        if (selectedKeys && selectedKeys.length > 0) {
                            entity.def.columns.c_superior_id.value = keys![0].c_personal_id;
                            await entity.API.executeProcess(entity.def.procs.perl_AsignarSuperior, procParms, abort_controller.signal, selectedKeys);
                        }
                        return { Results: [{ Status: 0, Message: 'OK' }] } as DBStatusResult;
                    }
                }
            />

        });

        return false;
    }
}